import request from "../utils/request"

export function fetchInviteCodes(params = {}) {
  return request({
    url: "/admin/invite-codes",
    method: "get",
    params
  })
}

export function saveInviteCode(data = {}) {
  return request({
    url: "/admin/invite-codes",
    method: "post",
    data
  })
}

export function updateInviteCodeStatus(id, status) {
  return request({
    url: `/admin/invite-codes/${id}/status`,
    method: "post",
    params: { status }
  })
}

export function deleteInviteCode(id) {
  return request({
    url: `/admin/invite-codes/${id}`,
    method: "delete"
  })
}

export function fetchInviteCodeUsers(id) {
  return request({
    url: `/admin/invite-codes/${id}/users`,
    method: "get"
  })
}
